import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@hotjar/webapp/components/EmptyState';
import { measureAndLog } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';
import findHeatmapSvg from '../../icons/find-heatmap.svg';
import { EmptyPageMessageContainer } from './MessageContainer';

interface FindHeatmapsProps {
  onFindHeatmaps: () => void;
}

export const FindHeatmaps = ({ onFindHeatmaps }: FindHeatmapsProps): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    // Perf: Mark default empty view timing

    measureAndLog({
      name: MARKS.HEATMAPS_DEFAULT_VIEW_RENDERED,
      startMark: MARKS.HEATMAPS_DEFAULT_VIEW_INITIALIZED,
    });
  }, []);

  return (
    <EmptyPageMessageContainer imgWidth={300}>
      <EmptyState
        img={findHeatmapSvg}
        title={t('heatmaps:empty-state.title')}
        subtitle={t('heatmaps:empty-state.subtitle')}
        buttonText={t('heatmaps:empty-state.button-text')}
        buttonKind="primary"
        onButtonClick={onFindHeatmaps}
      />
    </EmptyPageMessageContainer>
  );
};
